var exports = {
  "kL": "x7be19a29--3b71de--container",
  "f2": "x7be19a29--3b71de--container--after-tech",
  "vR": "x7be19a29--3b71de--tabs",
};

module.exports = exports;
